import client from './client';
import imageCompression from 'browser-image-compression';

const WEBP_MIME_TYPE = 'image/webp';
const WEBP_MAX_SIZE_MB = 2;
const WEBP_MAX_WIDTH_OR_HEIGHT = 1920;
const WEBP_INITIAL_QUALITY = 0.82;

const toWebpFilename = (filename: string) => {
    const baseName = filename.replace(/\.[^/.]+$/, '');
    return `${baseName || 'image'}.webp`;
};

const compressImageToWebp = async (file: File): Promise<File> => {
    if (!file.type.startsWith('image/') || file.type === 'image/svg+xml') {
        return file;
    }

    const compressedFile = await imageCompression(file, {
        maxSizeMB: WEBP_MAX_SIZE_MB,
        maxWidthOrHeight: WEBP_MAX_WIDTH_OR_HEIGHT,
        initialQuality: WEBP_INITIAL_QUALITY,
        fileType: WEBP_MIME_TYPE,
        useWebWorker: true,
    });

    return new File([compressedFile], toWebpFilename(file.name), {
        type: WEBP_MIME_TYPE,
        lastModified: file.lastModified,
    });
};

export const uploadImage = async (
    file: File,
): Promise<{ url: string; filename: string }> => {
    const uploadFile = await compressImageToWebp(file);
    const formData = new FormData();
    formData.append('file', uploadFile);

    const response = await client.post('uploads', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
};
